import { Section } from '@policygenius/dif-ts-types';

const schema: Section = {
  nodeType: 'SECTION',
  content: '',
  urn: 'urn:pg:interview:section:continue-online-adverse-driving',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    section_continue_online_driver: {
      operation: '=',
      field: 'question_insured_risk_activity_adverse_driving.value',
      value: true,
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      content:
        'Have you had your license suspended or revoked, or had more than one ticket or accident in the past 5 years?',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving',
      },
      urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving',
      rules: {
        field: 'value.present',
        value: true,
        operation: '=',
      },
    },
    {
      nodeType: 'SECTION',
      content: '',
      urn: 'urn:pg:interview:section:continue-online-driver',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      presentationRules: {
        question_insured_risk_activity_driving_history_dwi_conviction_date: {
          operation: '=',
          field: 'question_insured_risk_activity_driving_history_dwi_conviction_history.value',
          value: true,
        },
        question_insured_risk_activity_driving_history_reckless_driving_conviction_date: {
          operation: '=',
          field: 'question_insured_risk_activity_adverse_driving_reckless_driving_history.value',
          value: true,
        },
        question_insured_risk_activity_adverse_driving_drivers_license_suspended_date: {
          operation: '=',
          field:
            'question_insured_risk_activity_adverse_driving_license_revoked_or_suspended.value',
          value: true,
        },
      },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'BOOLEAN',
          content: 'Have you been convicted of drunk driving (DUI/DWI) in the last 10 years?',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-driving-history-dwi-conviction-history',
            dataType: 'boolean',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-driving-history-dwi-conviction-history',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          content: 'When was your most recent conviction for drunk driving (DUI/DWI)?',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-driving-history-dwi-conviction-date',
            dataType: 'date',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-driving-history-dwi-conviction-date',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'BOOLEAN',
          content: 'Have you been convicted of reckless driving in the last 10 years?',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-reckless-driving-history',
            dataType: 'boolean',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-reckless-driving-history',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          content: 'When was your most recent conviction for reckless driving?',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-driving-history-reckless-driving-conviction-date',
            dataType: 'date',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-driving-history-reckless-driving-conviction-date',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'BOOLEAN',
          content: 'Has your license been revoked or suspended in the last 10 years?',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-license-revoked-or-suspended',
            dataType: 'boolean',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-license-revoked-or-suspended',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          content:
            'When was your most recent conviction resulting in a revoked or suspended license?',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-drivers-license-suspended-date',
            dataType: 'date',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-drivers-license-suspended-date',
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          content: 'Total number of moving violations during the last 6 months.',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-moving-violations-zero-to-six-months',
            dataType: 'integer',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-moving-violations-zero-to-six-months',
          choices: [
            { displayText: 'No tickets', value: 0 },
            { displayText: '1 ticket', value: 1 },
            { displayText: '2 tickets', value: 2 },
            { displayText: '3 tickets', value: 3 },
            { displayText: '4 tickets', value: 4 },
            { displayText: '5 tickets', value: 5 },
            { displayText: '6 tickets', value: 6 },
            { displayText: '7 tickets', value: 7 },
            { displayText: '8 tickets', value: 8 },
          ],
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          content: 'Total number of moving violations during the last year, more than 6 months ago',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-moving-violations-six-to-twelve-months',
            dataType: 'integer',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-moving-violations-six-to-twelve-months',
          choices: [
            { displayText: 'No tickets', value: 0 },
            { displayText: '1 ticket', value: 1 },
            { displayText: '2 tickets', value: 2 },
            { displayText: '3 tickets', value: 3 },
            { displayText: '4 tickets', value: 4 },
            { displayText: '5 tickets', value: 5 },
            { displayText: '6 tickets', value: 6 },
            { displayText: '7 tickets', value: 7 },
            { displayText: '8 tickets', value: 8 },
          ],
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          content:
            'Total number of moving violations during the last 2 years, more than 1 year ago',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-moving-violations-twelve-to-twentyfour-months',
            dataType: 'integer',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-moving-violations-twelve-to-twentyfour-months',
          choices: [
            { displayText: 'No tickets', value: 0 },
            { displayText: '1 ticket', value: 1 },
            { displayText: '2 tickets', value: 2 },
            { displayText: '3 tickets', value: 3 },
            { displayText: '4 tickets', value: 4 },
            { displayText: '5 tickets', value: 5 },
            { displayText: '6 tickets', value: 6 },
            { displayText: '7 tickets', value: 7 },
            { displayText: '8 tickets', value: 8 },
          ],
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          content:
            'Total number of moving violations during the last 3 years, more than 2 years ago',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-moving-violations-twentyfour-to-thirtysix-months',
            dataType: 'integer',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-moving-violations-twentyfour-to-thirtysix-months',
          choices: [
            { displayText: 'No tickets', value: 0 },
            { displayText: '1 ticket', value: 1 },
            { displayText: '2 tickets', value: 2 },
            { displayText: '3 tickets', value: 3 },
            { displayText: '4 tickets', value: 4 },
            { displayText: '5 tickets', value: 5 },
            { displayText: '6 tickets', value: 6 },
            { displayText: '7 tickets', value: 7 },
            { displayText: '8 tickets', value: 8 },
          ],
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          content:
            'Total number of moving violations during the last 5 years, more than 3 years ago',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-adverse-driving-moving-violations-thirtysix-to-sixty-months',
            dataType: 'integer',
          },
          urn: 'urn:pg:interview:question:insured-risk-activity-adverse-driving-moving-violations-thirtysix-to-sixty-months',
          choices: [
            { displayText: 'No tickets', value: 0 },
            { displayText: '1 ticket', value: 1 },
            { displayText: '2 tickets', value: 2 },
            { displayText: '3 tickets', value: 3 },
            { displayText: '4 tickets', value: 4 },
            { displayText: '5 tickets', value: 5 },
            { displayText: '6 tickets', value: 6 },
            { displayText: '7 tickets', value: 7 },
            { displayText: '8 tickets', value: 8 },
          ],
          rules: {
            operation: '=',
            field: 'value.present',
            value: true,
          },
        },
      ],
    },
  ],
};

export default schema;
